module.exports = __webpack_public_path__ + "static/media/ic_web_clipboard-alt-gray.73336de5.svg";